export default __webpack_public_path__ + "static/media/our-partner-logo-16.85e1b2fb.jpeg";